var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.87,16.84l-.28-.54a10.13,10.13,0,0,0-1.48-2.44,1.17,1.17,0,0,0-1.38-.23,3.59,3.59,0,0,0-.7.59,2.4,2.4,0,0,1-1.5.5H24a2.34,2.34,0,0,1-1.54-.52,3.93,3.93,0,0,0-.7-.58,1.28,1.28,0,0,0-1.51.23,12.4,12.4,0,0,0-1.53,2.34v.07a1.63,1.63,0,0,1,1.59.45,11.17,11.17,0,0,1,.88,1.17h7.85a1.06,1.06,0,0,0,.88-.3A1.05,1.05,0,0,0,29.87,16.84Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.78,20l-.27-.55A9.46,9.46,0,0,0,20,17.07a1.15,1.15,0,0,0-1.38-.24,3.85,3.85,0,0,0-.7.58,2.37,2.37,0,0,1-1.53.5h-.49a2.35,2.35,0,0,1-1.55-.51,5.64,5.64,0,0,0-.69-.59,1.25,1.25,0,0,0-1.5.24,11.31,11.31,0,0,0-1.58,2.34l-.1.22a1.55,1.55,0,0,1,1.53.46,11.21,11.21,0,0,1,.76,1.05H21a1.1,1.1,0,0,0,.93-.31A1,1,0,0,0,21.78,20Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,24.54a1.19,1.19,0,0,1-.93-.33c-.16-.21,0-.61,0-.84l.26-.55a11.37,11.37,0,0,1,1.53-2.4,1.26,1.26,0,0,1,1.5-.25,5,5,0,0,1,.7.59,2.3,2.3,0,0,0,1.49.51h.49a2.33,2.33,0,0,0,1.53-.5,4,4,0,0,1,.71-.59,1.17,1.17,0,0,1,1.38.24,10.38,10.38,0,0,1,1.44,2.45l.27.53a1.1,1.1,0,0,1,.08.85,1.11,1.11,0,0,1-.93.3Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09,16.28a3.44,3.44,0,0,0,3.22-3.61v-.08A3.3,3.3,0,0,0,16.09,9.2H16a3.31,3.31,0,0,0-3.16,3.47v0A3.45,3.45,0,0,0,16.09,16.28Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82,19.6A3.42,3.42,0,0,0,11,16v-.09a3.3,3.3,0,0,0-3.2-3.39h0A3.29,3.29,0,0,0,4.67,16h0A3.51,3.51,0,0,0,7.82,19.6Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,13.08a3.44,3.44,0,0,0,3.27-3.6V9.43h0A3.32,3.32,0,0,0,24.27,6H24.2A3.3,3.3,0,0,0,21,9.42h0A3.44,3.44,0,0,0,24.2,13.08Z",
    style: {
      fill: "#00a6e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.3a26c60a.svg";
export { ForwardRef as ReactComponent };